import React from 'react';

/**
 * Banner displayed at the top of pages when a user account was created in a
 * test/dev environment but is being accessed on production.
 */
const isProductionDomain = () => {
  const host = window.location.hostname;
  return host === 'jetogo.com' || host === 'www.jetogo.com';
};

const DevEnvironmentBanner = () => {
  if (!isProductionDomain()) {
    return null;
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center flex-wrap">
          <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-amber-100">
              <svg
                className="h-5 w-5 text-amber-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </span>
            <p className="ml-3 font-medium text-amber-700 truncate">
              <span className="md:hidden">Dev account — limited functionality</span>
              <span className="hidden md:inline">
                Your account was created in a test environment. Payments and subscriptions may not work correctly. Please create a new account at jetogo.com
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevEnvironmentBanner;
